import React, { useMemo } from 'react';
import { View, Text, type TextStyle, type ViewStyle } from 'react-native';
import { useTranslation, getApiText } from '../../shared/i18n';
import { resolveRecipeDisplay } from '../../data/domains/foodMenu';

type FoodItemRecipeSectionStyles = {
  ingredientsContainer: ViewStyle;
  sectionTitle: TextStyle;
  ingredientsList: ViewStyle;
  ingredientChip: ViewStyle;
  ingredientText: TextStyle;
  recipeText: TextStyle;
};

type FoodItemRecipeSectionProps = {
  item: Record<string, unknown>;
  styles: FoodItemRecipeSectionStyles;
};

export function FoodItemRecipeSection({ item, styles }: FoodItemRecipeSectionProps) {
  const { t } = useTranslation();
  const display = useMemo(() => resolveRecipeDisplay(item), [item]);

  if (display.mode === 'none') {
    return null;
  }

  if (display.mode === 'text') {
    return (
      <View style={styles.ingredientsContainer}>
        <Text style={styles.sectionTitle}>{t('foodItemDetail.recipe')}</Text>
        <Text style={styles.recipeText}>{display.recipe_text}</Text>
      </View>
    );
  }

  return (
    <View style={styles.ingredientsContainer}>
      <Text style={styles.sectionTitle}>{t('foodItemDetail.ingredients')}</Text>
      <View style={styles.ingredientsList}>
        {(display.recipe_items ?? []).map((recipe, index) => {
          const row = recipe as Record<string, unknown>;
          const label =
            getApiText(row, 'title', 'a_title') ||
            (typeof row.name === 'string' ? row.name : '') ||
            (typeof row.title === 'string' ? row.title : '') ||
            t('foodItemDetail.ingredientFallback');
          return (
            <View key={index} style={styles.ingredientChip}>
              <Text style={styles.ingredientText}>{label}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}
